var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-textarea',{attrs:{"disabled":"","label":"Disabled","hint":"Hint text","rows":"2"}}),_c('v-textarea',{attrs:{"readonly":"","rows":"2","label":"Readonly","hint":"Hint text"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }